
    <div class="ui-dialog-content ui-g-12" *ngIf="labels">
      <app-kontable
                    id="kon_movements"
                    title="{{ 'customers.loyalty_movements' | translate }}"
                    [columns]="['card_no',
                    { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: selectFilter, filterOptions: {values: listMovementStatus}},
                    { field: 'reasonDescription', title: 'customers.reason_id' },
                    'store_name',
                    { field: 'xact_date', title: 'customers.movement_xact_date', bodyTemplate: xactDateTemplate },
                    { field: 'xact_time', title: 'customers.movement_xact_time', bodyTemplate: xactTimeTemplate },
                    {field: 'value', title: 'extClusterAnalytics.value'}
                    ]"
                    [titles]="['customers.card_no',
                    'customers.movement_store_id',
                    'common.store_name'
                    ]"
                    [source]="accumulatorMovements"
                    [showGlobalFilter]="false"
                    [showDetailsButton]="false"
                    [showInfoButton]="false"
                    [showRecoverButton]="false"
                    [showAddButton]="false"
                    [showEditButton]="false"
                    [showDeleteButton]="false"
                    [paginationType]="paginationType"
      >

      <ng-template #stateTemplate let-row>
        <span *ngIf="row.flg_state && row.flg_state == '0'">{{labels.status_notDeleted}}</span>
        <span *ngIf="row.flg_state && row.flg_state == '1'">{{labels.status_onlyDeleted}}</span>
        <span *ngIf="row.flg_state && row.flg_state == '2'">{{labels.status_onlySuspended}}</span>
      </ng-template>

        <ng-template #xactDateTemplate let-row>
          <span *ngIf="selectedLanguage != 'it'">{{row['xact_date'] | date: 'yyyy-MM-dd'}}</span>
          <span *ngIf="selectedLanguage == 'it'">{{row['xact_date'] | date: 'dd/MM/yyyy'}}</span>
        </ng-template>

        <!-- <ng-template #statusTemplate let-col>
          <span>{{row['xact_date'] | date: 'yyyy-MM-dd'}}</span>
        </ng-template> -->

        <ng-template #xactTimeTemplate let-row>
          {{convertTime(row['xact_time'])}}
        </ng-template>
      </app-kontable>

    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/movementsDialog.component.ts.MovementsDialogComponent.html